import { IonIcon } from '@ionic/react';
import { lockClosed } from 'ionicons/icons';

export const CleanSheetIcon: React.FC = () => (
  <IonIcon icon={lockClosed} />
);
